import React, { useState, useEffect } from 'react';
import { CopyFilled, QrcodeOutlined, ShareAltOutlined, WhatsAppOutlined } from '@ant-design/icons';

export default function LikeButton({ slug }) {
  const [liked, setLiked] = useState(false);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (slug && typeof window !== 'undefined') {
      const postLike = JSON.parse(localStorage.getItem('postLike') || '{}');
      setLiked(!!postLike[slug]);
    }
  }, [slug]);

  useEffect(() => {
    if (liked) {
      setAnimate(true);
      const timer = setTimeout(() => setAnimate(false), 600);
      return () => clearTimeout(timer);
    }
  }, [liked]);

  const handleLike = () => {
    if (!slug || typeof window === 'undefined') return;

    const newLikedState = !liked;
    setLiked(newLikedState);

    const postLike = JSON.parse(localStorage.getItem('postLike') || '{}');
    if (newLikedState) {
      postLike[slug] = true;
    } else {
      delete postLike[slug];
    }
    localStorage.setItem('postLike', JSON.stringify(postLike));
  };

  // // Method 1: Facebook Messenger Share
  // const shareViaMessenger = () => {
  //   if (!slug || typeof window === 'undefined') return;

  //   const currentUrl = encodeURIComponent(`${window.location.origin}/post/${slug}`);
  //   const messengerUrl = `https://www.facebook.com/dialog/send?link=${currentUrl}&app_id=YOUR_APP_ID&redirect_uri=${currentUrl}`;

  //   window.open(messengerUrl, 'messenger-share', 'width=626,height=436');
  // };

  // Method 2: WhatsApp Share
  const shareViaWhatsApp = () => {
    if (!slug || typeof window === 'undefined') return;

    const currentUrl = `${window.location.origin}/post/${slug}`;
    const text = `Check out this post: ${currentUrl}`;
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(text)}`;

    window.open(whatsappUrl, 'whatsapp-share');
  };

  // Method 3: Telegram Share
  // const shareViaTelegram = () => {
  //   if (!slug || typeof window === 'undefined') return;

  //   const currentUrl = `${window.location.origin}/post/${slug}`;
  //   const text = 'Check out this post!';
  //   const telegramUrl = `https://t.me/share/url?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(text)}`;

  //   window.open(telegramUrl, 'telegram-share');
  // };

  // Method 4: Email Share
  // const shareViaEmail = () => {
  //   if (!slug || typeof window === 'undefined') return;

  //   const currentUrl = `${window.location.origin}/post/${slug}`;
  //   const subject = 'Check out this post!';
  //   const body = `I thought you might find this interesting: ${currentUrl}`;
  //   const emailUrl = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  //   window.location.href = emailUrl;
  // };

  // Method 5: QR Code Generator for sharing
  const generateQRCode = () => {
    if (!slug || typeof window === 'undefined') return;

    const currentUrl = `${window.location.origin}/post/${slug}`;
    const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(currentUrl)}`;

    // Show QR code in modal or new window
    const qrWindow = window.open('', 'qr-code', 'width=350,height=350');
    qrWindow.document.write(`
      <html>
        <head><title>QR Code</title></head>
        <body style="text-align:center; padding:20px;">
          <h3>Quét tại đây</h3>
          <img src="${qrUrl}" alt="QR Code" />
          <p><small>Quét bằng camera để mở liên kết</small></p>
        </body>
      </html>
    `);
  };

  return (
    <>
      <style>{`
        .like-button {
          @apply relative inline-flex items-center justify-center cursor-pointer select-none transition-colors duration-300 ease-in-out;
        }
        
        .like-icon {
          @apply transition-transform duration-300 ease-in-out;
          color: #6b7280;
        }
        .like-button.liked .like-icon {
          color: #1877f2;
        }
        .like-icon.jump {
          animation: jumpUp 0.6s cubic-bezier(0.38, 0, 0.63, 1);
        }
        
        /* Jump animation keyframes */
        @keyframes jumpUp {
          0% { transform: translateY(0); }
          50% { transform: translateY(-10px) scale(1.2); }
          100% { transform: translateY(0) scale(1); }
        }

        /* Container cho toàn bộ share section */
        .share-wrapper {
          display: flex;
          align-items: center;
          position: relative;
          overflow: hidden;
        }
        
        /* Share buttons container */
        .share-buttons-container {
          
          align-items: center;
          transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          transform: translateX(100%);
          opacity: 0;
          pointer-events: none;
        }
        
        .share-buttons-container.active {
          transform: translateX(0);
          opacity: 1;
          pointer-events: auto;
        }

        /* Staggered animation cho từng button */
        .share-btn {
          transition: all 0.3s ease;
          transform: translateX(20px);
          opacity: 0;
        }
        
        .share-buttons-container.active .share-btn:nth-child(1) {
          animation: slideInButton 0.3s ease forwards 0.1s;
        }
        
        .share-buttons-container.active .share-btn:nth-child(2) {
          animation: slideInButton 0.3s ease forwards 0.2s;
        }
        
        .share-buttons-container.active .share-btn:nth-child(3) {
          animation: slideInButton 0.3s ease forwards 0.3s;
        }

        @keyframes slideInButton {
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }

        /* Hover effects */
        .share-btn:hover {
          transform: translateY(-2px) scale(1.05);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
        
        .main-share-btn {
          transition: transform 0.3s ease;
        }

        /* Responsive design */
        @media (max-width: 640px) {
          .share-buttons-container {
            gap: 6px;
          }
          
          .share-btn {
            width: 28px !important;
            height: 28px !important;
          }
        }
      `}</style>

      <div className="flex share-wrapper">
        {/* Like Button */}
        <button
          aria-pressed={liked}
          aria-label={liked ? 'Unlike' : 'Like'}
          className={`w-8 h-8 bg-white rounded-lg border border-gray-600 like-button main-share-btn ${liked ? 'liked' : ''} mr-2`}
          onClick={handleLike}
          type="button">
          <ShareAltOutlined size={15} className={`like-icon ${animate ? '' : ''}`} />
        </button>

        {/* Share Options Grid */}

        <div className={`share-buttons-container ${liked ? 'active flex' : 'hidden'}`}>
          <button
            onClick={shareViaWhatsApp}
            className="w-8 h-8 bg-green-500 
                      border border-green-500 rounded-lg hover:bg--green-300 mr-2 transition-colors share-btn"
            title="Chia sẻ WhatsApp">
            <WhatsAppOutlined size={15} />
          </button>

          {/* <button
              onClick={shareViaTelegram}
              className="w-8 h-8 bg-blue-500 
                      border border-blue-500 rounded-lg hover:bg--blue-300  transition-colors"
              title="Share via Telegram">
              <Tele
            </button> */}

          {/* <button
              onClick={shareViaEmail}
              className="w-8 h-8 bg-gray-500 
                      border border-gray-500 rounded-lg hover:bg--gray-300 mr-2 transition-colors"
              title="Share via Email">
              <MailOutlined size={15} />
            </button> */}

          <button
            onClick={generateQRCode}
            className="w-8 h-8 bg-purple-500 
                      border border-purple-500 rounded-lg hover:bg--purple-300 mr-2 transition-colors share-btn"
            title="Sinh QR Code bài viết">
            <QrcodeOutlined size={15} />
          </button>

          <button
            onClick={() => {
              const url = `${window.location.origin}/post/${slug}`;
              navigator.clipboard.writeText(url);
              alert('Đã sao chép link bài viết!');
            }}
            className="w-8 h-8 bg-orange-500 
                      border border-orange-500 rounded-lg hover:bg--orange-300 mr-2 transition-colors share-btn"
            title="Sao chép Link">
            <CopyFilled size={15} />
          </button>
        </div>
      </div>
    </>
  );
}
